module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAIAAACX9VFYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADcSURBVDhPY/z//z8DWYAJSpMORnUSAkNS57sPn9bv2PPpy1cIFxk8e/l6w869P3/9hvJhAKrz798/5y5dnb101eu37yAiEHDr3oPJ8xY/fvrs//9/UCEYQKTbV6/fzl6++s/vP4kRQbLSUgz//5++cHnFxm26Gqph/l7cnJwQZXCAkuI/fvq8YNX6Zy9exoT4P3vxatveAw5WFt4u9mysrFAVSAA9r3z/8WPlpu1A21iYmUN8PKxMDJmZcYQiUCca+PXr95bd+6/cuP3v3z+oEDYwmj8JgaGkk4EBACjXk1kMa24GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/schedule-arrow-down.png
// module id = 803
// module chunks = 0